MS = window.MS || {};

(function($) {

  var $window = $(window);
  var $document = $(document);
  var $html = $('html');
  var $body = $('body');

  var siteName  = $('[property="og:site_name"]').attr('content');

  // GUID helper
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  function guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }



  // The SultrySaltNav class
  // ------------------------------------------------
  var SaltNav = function ($element) {
    this.$element = $($element);

    // Instance ID
    var ID = guid();
    this.__defineGetter__('ID', function () {
      return ID;
    });

    // Permalinks mapping
    this.permalinksMapping = this.generatePermalinksMapping();

    // Bind elements
    this.bindElemens();

    // Attach reference to instance
    this.$element[0].SaltNav = this;
  };



  // SultrySaltNav Prototype
  // ------------------------------------------------
  SaltNav.prototype = $.extend({}, SaltNav.prototype, {

    // Binds element events
    bindElemens: function () {
      var that = this;
      var $subLinks = this.$element.find('.ms-ss_module__nav-sub__link');

      $subLinks.on('click', function (e) {
        var href = e.target.href;

        // Activate selected permalink for all nav instances
        e.preventDefault();
        MS.sultrysalt_nav.activateByPermalink(e.target.href, true);
      });
    },

    /*
      Generates an object containing sublinks,
      keyed according to their permalinks

      @returns:
      [
        {
          permalink: [String]               // --> the permalink string
          $element: [jQueryElement]         // --> .ms-ss_module__nav-sub__item
          $link: [jQueryElement]            // --> .ms-ss_module__nav-sub__item
          $saltTypeLink: [jQueryElement]    // --> .ms-ss_module__nav-item
          videoID: [String]                 // --> youtube video id of the permalink's post
          postID: [Number]                  // --> post id of the permalink's post
          postTitle: [String]               // -> post_title of the permalink's post
        }
      ]
    */
    generatePermalinksMapping: function () {
      var permalinksMapping = [];
      var $primaryItems = this.$element.find('.ms-ss_module__nav-item');

      $.map($primaryItems, function (element) {
        var $primaryItem = $(element);
        var $saltTypeLink = $primaryItem.find('.ms-ss_module__nav-link');
        var $subItems = $primaryItem.find('.ms-ss_module__nav-sub__item');

        $subItems.each(function () {
          var $subItem = $(this);
          var $subLink = $subItem.find('.ms-ss_module__nav-sub__link');
          var permalink = $subLink.attr('href');

          // Add permalink element and salt type parent references
          permalinksMapping.push({
            permalink: permalink,
            $element: $subItem,
            $link: $subLink,
            $saltTypeLink: $saltTypeLink,
            videoID: $subItem.data('videoId'),
            postID: $subItem.data('postId'),
            postTitle: $subItem.data('postTitle'),
          });
        });
      });

      return permalinksMapping;
    },

    // Activates a sublink and its parent salt according to permalink
    activateByPermalink: function (permalink) {
        var targetPermalinkObjects = this.permalinksMapping.filter(function (permalinkObject) {
          return permalinkObject.permalink === permalink;
        });

        if ( targetPermalinkObjects.length ) {

          // Deactivate active links
          this.deactivateActiveLink();

          // Activate target permalink
          targetPermalinkObjects.map(function (permalinkObject) {
            permalinkObject.$element.addClass('active');
            permalinkObject.$saltTypeLink.addClass('active');
          });
        }
    },

    deactivateActiveLink: function () {
      this.$element.find('.active').removeClass('active');
    }

  });



  // SultySaltNav Module
  // ------------------------------------------------
  MS.sultrysalt_nav = {

    instances: [],
    activePermalink: null,

    init: function () {

      var that = this;
      var $elements = $('.ms-ss_module__nav');

      // Reset intances
      this.instances = [];

      // Check for each instances for each element
      $elements.each(function (index, element) {
        if ( element.SaltNav && element.SaltNav instanceof SaltNav ) {
          return that.instances.push(element.SaltNav);
        }
        that.instances.push(new SaltNav(element));
      });

      // Ensure correct link is activated
      this.activateByPermalink(window.location.href);
    },


    /**
     * Activates nav link for all instances using permalink
     *
     * @param {String} permalink - The target permalink
     * @param {Boolean} replaceContents - Whether to replace the hero video and recipe using the target permalink's post. Defaults to false
     */
    activateByPermalink: function (permalink, replaceContents) {


      if ( this.activePermalink === permalink) { return; }


      this.instances.forEach(function (instance) {
        instance.activateByPermalink(permalink);
      });

      this.activePermalink = permalink;

      // Get video id and recipe id to load
      var activePermalink = this.instances[0].permalinksMapping.filter(function (permalinkObject) {
        return permalinkObject.permalink === permalink;
      })[0];

      if ( !activePermalink ) { return; }

      // Save history
      window.history.pushState({},activePermalink.postTitle,this.activePermalink);
      document.title = activePermalink.postTitle + ' - ' + siteName;

      // Replace sticky nav title
      if ( MS.sultrysalt_sticky_nav ) {
        MS.sultrysalt_sticky_nav.changeTitle(activePermalink.postTitle);
      }

      // Proceed to changing video and recipe if replaceContents is true
      if ( !replaceContents ) { return; }

      // Replace video
      if ( MS.sultrysalt_hero ) {
        MS.sultrysalt_hero.replaceRecipeVideo(activePermalink.videoID);
      }

      // Pause persistent bar video
      if ( MS.sultrysalt_persistent_bar ) {
        MS.sultrysalt_persistent_bar.pause();
      }

      // Replace recipe
      if ( MS.sultrysalt_recipe_transporter ) {
        MS.sultrysalt_recipe_transporter.loadRecipe(activePermalink.postID);
      }

    }

  };

})(jQuery);
